import 'scheduler-polyfill'

export default defineNuxtPlugin(() => {
  window.scheduler = scheduler
})
